export default "__VITE_ASSET__CIiZkNEZ__"